import { Box } from "@chakra-ui/react"

export default function Pressable({ label, disabled = false, onClick = () => {}, ...props }){
    return(
        <Box cursor={disabled ? 'not-allowed' : 'pointer'} __css={{ transition: 'all 300ms' }} style={ disabled ? { opacity: 0.5 } : null } _hover={disabled ? null : { opacity: 0.5 }} _active={disabled ? null : { opacity: 1, transform: 'scale(0.99)' }} onClick={disabled ? null : onClick} {...props} />
    )
}